//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditFare from "./OrderPop/EditFare.vue";
import EditHavest from "./OrderPop/EditHavest.vue";
import remarkDialog from "./OrderPop/Remark.vue";
import cancelDialog from "./OrderPop/CancelOrder.vue";
import EditCost from "./OrderPop/EditCost.vue";
import SendGoods from "./OrderPop/SendGoods.vue";
export default {
  data() {
    return {
      msg: {
        releaseTime: "2017-07-19 15:43:23",
        meetTime: "未议价",
        taskStart: "",
        taskEnd: "",
        paymentTime: "",
        payment: "",
      },
      infoOrder: [
        {
          orderNum: "",
          receiver: "",
          createTime: "",
          orderSource: "",
          types: "",
          payStatus: "",
          expectedTime:''
        },
      ],
      infoPayment: [
        {
          createTime: "",
          remark: "",
          imgUrl: [],
        },
      ],
      infoWlment: [
        {
          saleOrderTime: "",
          remark: "",
          contacts: "",
          telPhone: "",
        },
      ],
      infoGoods: [
        {
          goodsImg: "",
          goodsName: "",
          goodsPrice: "",
          goodsAttribute: "",
          goodsNum: "",
          totalPay: "",
        },
      ],

      infoFare: [
        {
          totalPay: "",
          freightMoney: "",
          discountPrices: "",
          oredrPrice: "",
          remitMoneyPrice: "",
          id: "",
        },
      ],
      infoFares: [],
      infoOperate: [
        {
          saleOrderTime: "201707196398345",
          remark: "张三合作社",
          contacts: "2022-10-10",
          telPhone: "合作社",
          orderBuy: "自主下单",
          payOrder: "线下全款",
          note: "备注",
        },
      ],
      infoFp: [
        {
          billTypes: "",
          billTitle: "",
          billInfo: "",
          // payeeMsg: "",
          payeeTel: "",
          payeeMailbox: "",
          status: "",
          id: "",
          billTitle: "",
          socialCreditCode: "",
          address: "",
          telephone: "",
          bankName: "",
          accountNum: "",
        },
      ],
      infoSh: [
        {
          receiver: "",
          telphone: "",
          addr: "",
        },
      ],
      state_flow: [],
      // state_cancel: [
      //   { name: "提交订单", date: "2022-07-14 09:39:55", is_choice: "Y" },
      //   {
      //     name: "关闭",
      //     date: "2022-07-14 09:39:55",
      //     is_choice: "N",
      //     reason: "取消原因：重复下单/误下单",
      //   },
      // ],
      state_cancel: [],
      orderStatus: "",
      orderName: "",
      fareStatus: "",
      havestStatus: false,
      remarkStatus: false,
      checkStatus: false,
      costStatus: false,
      orderId: "",
      goodsInfo: {},
      invoicesInfo: {},
      orderInfo: {},
      payListInfo: {},
      payInfo: {},
      payImgInfo: {},
      sendStatus: false,
      fpStatus: "",
      infoWlmentInfo: {},
      showDialogPrice: false,
      showDialogPayment: false,
      showDialogDelete: false,
      infoFpObj: {},
    };
  },
  components: {
    EditFare,
    EditHavest,
    remarkDialog,
    cancelDialog,
    EditCost,
    SendGoods,
  },
  filters: {
    filterPayStatus(val) {
      if (val == 10) {
        return "线下";
      } else if (val == 20) {
        return "贷款";
      } else if (val == 30) {
        return "部分贷款";
      } else if (val == 40) {
        return "银行转账";
      } else if (val == "") {
        return "暂无";
      }
    },
    filterOrderStatus(val) {
      if (val == 0) {
        return "自主下单";
      } else if (val == 1) {
        return "运营后台下单";
      }
    },
    fpStatusFn(val) {
      if (val == 0) {
        return "个人";
      } else if (val == 1) {
        return "单位";
      }
    },
  },
  created() {
    this.orderStatus = this.$route.query.orderStatus;
    this.orderId = this.$route.query.id;
    if (this.orderStatus == "10") {
      this.orderName = "待议价";
    } else if (this.orderStatus == "20") {
      this.orderName = "待付款";
    } else if (this.orderStatus == "30") {
      this.orderName = "待确认付款";
    } else if (this.orderStatus == "40") {
      this.orderName = "待发货";
    } else if (this.orderStatus == "50") {
      this.orderName = "已发货";
    } else if (this.orderStatus == "60") {
      this.orderName = "已完成";
    } else if (this.orderStatus == "0") {
      this.orderName = "已取消";
    }
  },
  mounted() {
    // let targetFlag = this.$route.query.flag;
    // if (targetFlag == 1) {
    //   this.$route.meta.targetPath = "/szoperation/order/list";
    // } else if (targetFlag == 2) {
    //   this.$route.meta.targetPath = "/szoperation/order/bargain";
    // } else if (targetFlag == 3) {
    //   this.$route.meta.targetPath = "/szoperation/order/payment";
    // } else if (targetFlag == 4) {
    //   this.$route.meta.targetPath = "/szoperation/order/deliver";
    // } else if (targetFlag == 5) {
    //   this.$route.meta.targetPath = "/szoperation/order/harvest";
    // }
    this.getGoodsInfo();
  },
  methods: {
    // 获取订单详情接口
    getGoodsInfo() {
      this.fpStatus = "";
      this.$http.szOrder
        .getOrder({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            let goodsData = res.data;
            this.goodsInfo = goodsData.goods;
            this.invoicesInfo = goodsData.invoices;
            this.orderInfo = goodsData.order;
            this.payListInfo = goodsData.payList;
            this.payInfo = goodsData.pay;
            this.payImgInfo = goodsData.payImg;
            this.infoWlmentInfo = goodsData.delivery;

            // 订单流程
            this.state_flow = goodsData.flowsheet;
            this.state_cancel = goodsData.flowsheet;

            // 发票信息
            if (this.invoicesInfo != null) {
              this.infoFp[0].billTypes = this.invoicesInfo.billTypes;
              this.infoFp[0].billTitle = this.invoicesInfo.billTitle;
              this.infoFp[0].billInfo = this.invoicesInfo.billInfo;
              this.invoicesInfo.payeeTel =
                this.invoicesInfo.payeeTel != null
                  ? this.invoicesInfo.payeeTel
                  : "";
              this.invoicesInfo.payeeMailbox =
                this.invoicesInfo.payeeMailbox != null
                  ? this.invoicesInfo.payeeMailbox
                  : "";
              // this.infoFp[0].payeeMsg =
              //   this.invoicesInfo.payeeTel +
              //   " " +
              //   this.invoicesInfo.payeeMailbox;
              this.infoFp[0].payeeTel = this.invoicesInfo.payeeTel;
              this.infoFp[0].payeeMailbox = this.invoicesInfo.payeeMailbox;
              this.infoFp[0].status = this.invoicesInfo.status;
              this.fpStatus = this.invoicesInfo.status;
              this.infoFp[0].id = this.invoicesInfo.id;
              this.infoFp[0].billTitle = this.invoicesInfo.billTitle;
              this.infoFp[0].socialCreditCode =
                this.invoicesInfo.socialCreditCode;
              this.infoFp[0].address = this.invoicesInfo.address;
              this.infoFp[0].telephone = this.invoicesInfo.telephone;
              this.infoFp[0].bankName = this.invoicesInfo.bankName;
              this.infoFp[0].accountNum = this.invoicesInfo.accountNum;
              // sessionStorage.setItem("infoFpObj", JSON.stringify(this.infoFp));

              // this.$store.state.szStatus.szFareDetails = this.infoFp[0];
            } else {
              this.infoFp = [];
            }

            // 物流信息
            if (this.infoWlmentInfo != null) {
              this.infoWlment[0].saleOrderTime =
                this.infoWlmentInfo.saleOrderTime;
              this.infoWlment[0].contacts = this.infoWlmentInfo.contacts;
              this.infoWlment[0].telPhone = this.infoWlmentInfo.telPhone;
              this.infoWlment[0].remark = this.infoWlmentInfo.remark;
            } else {
              this.infoWlment = [];
            }

            //订单基本信息
            if (this.orderInfo != null) {
              this.infoOrder[0].orderNum = this.orderInfo.orderNum;
              this.infoOrder[0].receiver = this.orderInfo.receiver;
              this.infoOrder[0].createTime = this.orderInfo.createTime;
              this.infoOrder[0].orderSource = this.orderInfo.orderSource;
              this.infoOrder[0].expectedTime = this.orderInfo.expectedTime;
              this.infoOrder[0].types = this.orderInfo.types;
              this.infoOrder[0].payStatus =
                this.pay != null && this.pay ? this.pay.status : "";

              // 收货人信息
              this.infoSh[0].receiver = this.orderInfo.receiver;
              this.infoSh[0].telphone = this.orderInfo.telphone;
              this.infoSh[0].addr = this.orderInfo.addr;
              this.$store.state.szStatus.receiverObj = this.infoSh[0];
              // sessionStorage.setItem("infoShObj", JSON.stringify(this.infoSh));
            } else {
              this.infoOrder = [];
              this.infoSh = [];
            }

            // 商品信息
            if (this.goodsInfo != null) {
              this.infoGoods[0].goodsImg = this.goodsInfo.goodsImg;
              this.infoGoods[0].goodsName = this.goodsInfo.goodsName;
              this.infoGoods[0].goodsPrice = this.goodsInfo.goodsPrice;
              this.infoGoods[0].goodsAttribute = this.goodsInfo.goodsAttribute;
              this.infoGoods[0].goodsNum = this.goodsInfo.goodsNum;
              this.infoGoods[0].totalPay = this.goodsInfo.totalPay;
            } else {
              this.infoGoods = [];
            }

            // 费用信息
            if (this.payInfo != null) {
              // this.infoFare[0].totalPay = this.payInfo.totalPay;
              this.infoFare[0].totalPay =
                this.goodsInfo != null ? this.goodsInfo.totalPay : "";
              this.infoFare[0].freightMoney = this.payInfo.freightMoney;
              this.infoFare[0].discountPrices = this.payInfo.discountPrices;
              this.infoFare[0].oredrPrice = this.payInfo.oredrPrice;
              this.infoFare[0].remitMoneyPrice = this.payInfo.remitMoneyPrice;
              this.infoFare[0].id = this.payInfo.id;
              this.$store.state.szStatus.szDetailsObj = this.infoFare;
            } else {
              this.infoFare = [];
            }

            // 付款信息
            if (
              this.payImgInfo != null &&
              Object.keys(this.payImgInfo).length != 0
            ) {
              this.infoPayment[0].createTime = this.payImgInfo.createTime;
              this.infoPayment[0].remark = this.payImgInfo.remark;
              this.infoPayment[0].imgUrl = this.payImgInfo.imgUrl;
            } else {
              this.infoPayment = [];
            }
            console.log(this.infoPayment);
          }
        });
    },

    // 确认定价
    confirmPricing() {
      this.showDialogPrice = true;
    },
    confirmPrice() {
      this.$http.szOrder
        .confirmPricing({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "确定成功",
              type: "success",
              duration: 3000,
            });
            this.showDialogPrice = false;
            this.orderStatus = 20;
            this.getGoodsInfo();
          }
        });
    },

    // 确认付款
    confirmPayment() {
      this.showDialogPayment = true;
    },
    confirmPaymentBtn() {
      this.$http.szOrder
        .confirmPayment({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "付款核实成功",
              type: "success",
              duration: 3000,
            });
            this.showDialogPayment = false;
            this.getGoodsInfo();
            this.orderStatus = 40;
          }
        });
    },

    // 确认发货
    confirmDelivery() {
      this.sendStatus = true;
    },

    // 删除订单
    deleteOrder() {
      this.showDialogDelete = true;
    },
    confirmDelete() {
      this.$http.szOrder
        .deleteOrder({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.showDialogDelete = false;
            this.$router.push({ path: "/szoperation/order/list" });
          }
        });
    },
    // 修改发票信息
    checkFp() {
      this.fareStatus = true;
      this.infoFpObj = this.infoFp[0];
      this.$store.state.szStatus.szFareDetails = this.infoFpObj;
    },
    // 修改收货人信息
    getEditHavest() {
      this.havestStatus = true;
      this.infoFares = this.$store.state.szStatus.receiverObj;
      sessionStorage.setItem("orderId", this.orderId);
      console.log(this.infoFares);
      console.log(this.orderId);
    },
    // 修改备注信息
    getEditRemark() {
      this.remarkStatus = true;
    },
    // 修改商品信息
    getEditGoods() {
      sessionStorage.setItem("infoGoods", JSON.stringify(this.infoGoods));
      this.$router.push({
        path: "/szoperation/order/mendProdect",
        query: {
          // infoGoods: JSON.stringify(this.infoGoods),
          orderId: this.orderId,
        },
      });
    },
    // 修改费用信息
    getEditCost() {
      this.costStatus = true;
      this.infoFares = this.$store.state.szStatus.szDetailsObj;
      // sessionStorage.setItem("infoFareInfo", JSON.stringify(this.infoFare));
    },
    //取消订单
    getCancelOrder() {
      this.checkStatus = true;
    },
    getCloseStatus(val) {
      if (val == true) {
        this.fareStatus = false;
        this.havestStatus = false;
        this.remarkStatus = false;
        this.checkStatus = false;
        this.costStatus = false;
        this.getGoodsInfo();
      }
    },
    getCloseSendStatus(val) {
      if (val == true) {
        this.sendStatus = false;
        this.orderStatus = 50;
        this.getGoodsInfo();
      }
    },
    // getCancelStatus(val) {
    //   if (val == true) {
    //     // 调列表接口
    //     this.getGoodsInfo();
    //   }
    // },
  },
};
